export default __webpack_public_path__ + "static/media/Bass_Walker.53c0dccf.mp3";